import React, { useState } from "react";
import { useForm } from "react-hook-form";
// import {AddUserPostApi } from "../../../../Api/PanelAdminServices";
import Style from "./AddColorContainer.module.scss";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import {  ColorAPI } from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
// import '../AddSupplierContainer/AddSupplier.css'
// import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
// import TableFixedPage from './../../TableFixedPage/TableFixedPage';

const AddColorContainer = () => {
  const [disable, setDisable] = useState(false);


  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onsubmit = (data) => {
    setDisable(true)
    let info={
      color:data.color,
        action:'add'
    }
    ColorAPI(info,(succ,res)=>{
        if(succ){
          setDisable(false)
            if(res.status===1){
                succToast('انجام شد!')
              }else{
                errorToast(res.message)
              }
        }else{
            console.log(res)
            setDisable(false)
        }
    })
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"افزودن رنگ"} />
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>

         
          <input
            className={errors.name ? Style.errorInput : Style.inputPart}
            placeholder={"نام رنگ"}
            {...register("color", { required: true })}
          />

          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            اضافه کردن
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddColorContainer